import type { PartSvgProps } from './types'

export default function AkMagBananaSvg762 ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  width = 60,
  height = 88
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 60 88" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Feed lips */}
      <rect x="12" y="2" width="36" height="8" rx="2" fill={stroke} />
      {/* Banana body — 7.62x39: strong forward (left) curve, base shifts ~13% */}
      <path d="M 16,10 C 12,35 4,65 4,78 L 40,78 C 50,65 52,35 44,10 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Horizontal ribs */}
      <line x1="14" y1="32" x2="48" y2="32" stroke={stroke} strokeWidth="0.8" strokeOpacity="0.5" />
      <line x1="6" y1="53" x2="48" y2="53" stroke={stroke} strokeWidth="0.8" strokeOpacity="0.5" />
      <line x1="5" y1="70" x2="40" y2="70" stroke={stroke} strokeWidth="0.8" strokeOpacity="0.5" />
      {/* Base plate */}
      <rect x="2" y="75" width="40" height="8" rx="2" fill={stroke} />
    </svg>
  )
}
